<template>
  <div>
    <nav-title :color="true" :title="next == 'skill-planning' ? 'Create or edit your goals' : ''" />
    <progress-skills
      v-if="next != 'skill-planning'"
      :title="title"
      :subtitle="subtitle"
      :total="total"
      :completed="completed"
      :percentage="percentage"
    />
    <list-skills
      v-if="setSkillsList().length != 0"
      :skills="[...setSkillsList()].sort((a, b) => compare(a, b))"
    />
    <no-plan v-else />
  </div>
</template>
<script>
import navTitle from '@/components/general/navTitle.vue';
import progressSkills from '@/components/skills/progressSkills.vue';
import listSkills from '@/components/skills/listSkills.vue';
import noPlan from '@/components/planning/noPlan.vue';
import { mapGetters } from 'vuex';
import store from '@/store';

export default {
  components: {
    navTitle,
    progressSkills,
    listSkills,
    noPlan,
  },
  data() {
    return {
      from: this.$route.query.type,
      next: null,
      total: null,
      completed: null,
      percentage: null,
      title: null,
      subtitle: null,
    };
  },
  methods: {
    setSkillsList() {
      let skills = [];
      switch (this.from) {
        case 'learn':
          this.next = 'skill-description';
          skills = this.getLearnSkillList.skills;
          this.total = this.getLearnSkillList.skills.length;
          this.completed = this.getLearnSkillList.skills_checked;
          this.percentage = this.getLearnSkillList.skills_percentage;
          this.title = "You've learned";
          this.subtitle = 'skills';
          break;
        case 'create':
          this.next = 'skill-planning';
          skills = this.getPlanSkillList.skills;
          this.total = this.getPlanSkillList.skills.length;
          this.completed = this.getPlanSkillList.skills_checked;
          this.percentage = this.getPlanSkillList.skills_percentage;
          this.title = "You've created";
          this.subtitle = 'Parent Goals';
          break;
        case 'check':
          this.next = 'skill-practice';
          skills = this.getGoalsSkillList.skills;
          this.total = this.getGoalsSkillList.skills.length;
          this.completed = this.getGoalsSkillList.skills_checked;
          this.percentage = this.getGoalsSkillList.skills_percentage;
          this.title = "You've checked";
          this.subtitle = 'of your goals';
          break;
        case 'test':
          this.next = 'skill-rate';
          skills = this.getRateSkillList.skills;
          this.total = this.getRateSkillList.skills.length;
          this.completed = this.getRateSkillList.skills_checked;
          this.percentage = this.getRateSkillList.skills_percentage;
          this.title = "You've done";
          this.subtitle = 'Tests of parent skills';
          break;
        default:
          break;
      }
      // return skills.sort((a,b)=>this.compare(a,b));
      return skills;
    },
    goModuleSkill(Mid) {
      this.$router.push({
        path: `/${this.next}/${Mid}`,
      });
    },
    compare(a, b) {
      if (this.getFavoriteSkills) {
        if (this.getFavoriteSkills.includes(a.id)) {
          return -1;
        }
        if (this.getFavoriteSkills.includes(b.id)) {
          return 1;
        }
      }
      // a debe ser igual b
      return 0;
    },
  },
  computed: {
    ...mapGetters('planning', [
      'getLearnSkillList',
      'getPlanSkillList',
      'getGoalsSkillList',
      'getRateSkillList',
    ]),
    ...mapGetters('parent', ['getFavoriteSkills']),
  },

  beforeRouteEnter(to, from, next) {
    const parentId = store.getters['user/getUserId'];
    Promise.all([
      store.dispatch('planning/FetchLearnSkillList', parentId),
      store.dispatch('planning/FetchPlanSkillList', parentId),
      store.dispatch('planning/FetchGoalsSkillList', parentId),
      store.dispatch('planning/FetchRateSkillList', parentId),
      store.dispatch('parent/getParentFavoriteSkills', parentId),
    ]).then(() => {
      next();
    });
  },
};
</script>
